<template>
  <div>
    <div class="banner">
      <span>{{ $t("tech.banner") }}</span>
    </div>
    <div class="section-wrap">
      <div class="tab-nav clearfix c-333">
        <div :class="tab == 1 ? 'active' : ''" @click="tab = 1;routerSkip('/tech', 1);">{{$t("header.nav3_1")}}</div>
        <div :class="tab == 2 ? 'active' : ''"  @click="tab = 2; routerSkip('/tech', 2);">{{$t("header.nav3_2")}}</div>
        <div :class="tab == 3 ? 'active' : ''"  @click="tab = 3; routerSkip('/tech', 3);">{{$t("header.nav3_3")}}</div>
      </div>
      <div class="tab-content" :class=" (tab == 3 ? 'tab3' : '')">
        <div :class="'tab1 ' + (tab == 1 ? '' : 'hide')">
          <!-- <div class="rela video">
            <video id="video" v-show="videoPlay"  src="http://img.sensfoot.sdh5.com/media/video.mp4" poster="@/assets/images/tech/video.png" controls="false"></video>
            <div class="abso full" :style="'top:0;left:0;background:url('+require('@/assets/images/tech/video.png')+') no-repeat center/cover'" v-show="!videoPlay"></div>
            <div class="abso video-btn" id="video-btn" @click="videoEvent" v-show="!videoPlay">
              <img src="@/assets/images/public/video-btn.png">
              <p>创新防滑科技技术</p>
            </div>
          </div> -->
          <div class="tech-title tech-t tc">{{ $t("tech.t1") }}</div>
          <div class=" text1 tc" v-html="$t('tech.c1')"></div>
          <div class="tech-title tech-t tc sec">{{ $t("tech.t2") }}</div>

          <div class="clearfix design-wrap">
            <div class="fl design-left">
              <div class="rela">
                <img class="tech-img" src="@/assets/images/tech/design.png" />
                <div class="abso design-t">
                  <div class="d1">{{ $t("tech.d1") }}</div>
                  <div class="d2">{{ $t("tech.d2") }}</div>
                </div>
              </div>
              <div class="d3">{{ $t("tech.d3") }}</div>
            </div>
            <div class="fr d-list">
              <div
                class="clearfix d-list-item"
                v-for="(item, index) in d_list"
                :key="index"
              >
                <div class="fl icon-tri icon-tri-right rela mobile icon-f">{{ item.t1 }}</div>
                <div class="fl">{{ item.c1 }}</div>
                <div class="fr icon-tri icon-tri-left rela pc icon-f"><span>{{ item.t1 }}</span></div>
              </div>
            </div>
          </div>

          <img src="@/assets/images/tech/img1.jpg" class="tech-img"/>
          <div class="clearfix tech-b">
              <div
                class="clearfix d-list-item" :class="[(index%2 == 0 ? 'fl' : 'fr'), (index==3 ? 'last-tech' : '')]" 
                v-for="(item, index) in t_list"
                :key="index"
              >
              <div class="tech-i icon-tri  rela mobile fl icon-tri-right" >
                  <img class="tech-img" :src="item.img"/>
                </div>
                <div class="tech-i-t" :class="(index%2 == 0 ? 'fr' : 'fl')">{{ item.title }}</div>
                <div class="tech-i icon-tri  rela pc" :class="(index%2 == 0 ? 'fl icon-tri-right' : 'fr icon-tri-left')">
                  <img class="tech-img" :src="item.img"/>
                </div>
              </div>

          </div>

          <!-- <div class="tech-table-w">
            <div class="tech-table table">
              <div
                class="tech-cell table-cell tech-img1 icon-tri icon-tri-right"
              ></div>
              <div class="tech-cell table-cell">
                <p class="tech-title c-333">{{ $t("tech.cell[0].t1") }}</p>
                <p class="tech-label c-666">{{ $t("tech.cell[0].t2") }}</p>
                <div class="tech-text c-999">{{ $t("tech.cell[0].t3") }}</div>
              </div>
            </div>
            <div class="tech-table table">
              <div class="tech-cell table-cell">
                <p class="tech-title c-333">{{ $t("tech.cell[1].t1") }}</p>
                <p class="tech-label c-666">
                  {{ $t("tech.cell[1].t2") }}&按摩纹路
                </p>
                <div class="tech-text c-999">{{ $t("tech.cell[1].t3") }}</div>
              </div>
              <div
                class="tech-cell table-cell tech-img2 icon-tri icon-tri-left"
              ></div>
            </div>
            <div class="tech-table table">
              <div
                class="tech-cell table-cell tech-img3 icon-tri icon-tri-right"
              ></div>
              <div class="tech-cell table-cell">
                <p class="tech-title c-333">{{ $t("tech.cell[2].t1") }}</p>
                <p class="tech-label c-666">{{ $t("tech.cell[2].t2") }}</p>
                <div class="tech-text c-999">{{ $t("tech.cell[2].t3") }}</div>
              </div>
            </div>
          </div> -->
        </div>
        <div :class="tab == 2 ? '' : 'hide'">
          <ul class="clearfix tech-ul">
            <li
              class="tech-li"
              v-for="item in patent" :key="item.id"
              @click="
                showLayerBig = true;
                curImg = item.patentImage;
              "
            >
              <div>
                <div class="tech-li-img" >
                  <div class="tech-li-img-wrap" :style="{'background-image':'url('+item.patentImage+'?imageView2/2/w/400/interlace/1)'}"></div>
                </div>
                <div class="tech-li-info">
                  <p class="c-333 cbg-textOver">{{ item.patentName }}</p>
                  <p class="c-999 cbg-textOver">{{ item.label }}</p>
                </div>
                <img
                  src="@/assets/images/public/icon-jing.png"
                  class="abso pc icon-jing"
                />
                <img
                  src="@/assets/images/public/icon-jing-m.png"
                  class="abso mobile icon-jing"
                />
              </div>
            </li>
          </ul>
          <div v-show="patent.length == 0" class="tc">{{$t("common.date_list")}}</div>
          <div class="pagination clearfix" v-show="patent.length > 0">
            <a-pagination
              :class="$i18n.locale"
              v-model="listQuery.page"
              :page-size="listQuery.number"
              :total="listQuery.total"
              show-less-items
              @change="sizeChange"
            />
          </div>
        </div>
        <div :class="tab == 3 ? '' : 'hide'">
          <ul class="clearfix tech-ul">
            <li class="tech-li video-li" v-for="(item,index) in videoList" :key="item.id">
                <div>
                  <div class="rela video section2-video">
                  <video :id="'video'+item.id" ref="s2Video" :data-index="index" :src="item.materialVideo" :poster="item.frontCover" controls="false" class="abso" ></video>
                  <div class="abso full" :style="'top:0;left:0;background:url('+item.frontCover+') no-repeat center/cover'" v-show="!item.videoPlay"></div>
                  <div class="abso video-btn"  @click="videoEvent(item.id,index)" v-show="!item.videoPlay">
                    <img src="@/assets/images/public/video-btn.png">
                  </div>
              </div>
                <div class="tech-li-info">
                  <div class="c-333 cbg-textOver2 fl" :title="item.videoName">{{item.videoName}}</div>
                </div>
                </div>

            </li>
          </ul>
          <div v-show="videoList.length == 0" class="tc">{{$t("common.date_list")}}</div>
          <div class="pagination clearfix" v-show="videoList.length > 0">
            <a-pagination
              :class="$i18n.locale"
              v-model="listQuery2.page"
              :page-size="listQuery2.number"
              :total="listQuery2.total"
              show-less-items
              @change="sizeChange2"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="layerBig" v-show="showLayerBig">
      <div class="bg" @click="showLayerBig = false"></div>
      <div class="abso curImg">
        <img :src="curImg" class="curImg-big" />
        <img
          src="@/assets/images/public/icon-close.png"
          class="icon-close abso"
          @click="showLayerBig = false"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { selectPatent,selectVideoList } from "@api/index";
import { mapMutations, mapActions } from "vuex";
import { IsPC } from "@/utils/autoScale";

export default {
  name: "tech",
  data() {
    return {
      videoPlay: false,
      d_list: this.$t("tech.d_list"),
      t_list: [],
      tab: 1,
      patentImage: "@/assets/images/tech/img1.png",
      listQuery: {
        number: 12,
        page: 1,
        totalPage: 1,
        total: 18,
      },
      listQuery2:{
        number: 12,
        page: 1,
        totalPage: 1,
        total: 18,
      },
      curImg: "",
      showLayerBig: false,
      patent: [],
      videoList:[],
    };
  },
  created() {
    let t_list = []
    for(let i=0; i<=3; i++){
      t_list.push({
        title:this.$t('tech.t_list['+i+']'),
        img:require('@/assets/images/tech/icon'+(i+1)+'.png'),
      })
    }
    this.t_list = t_list
  },
  watch: {
    $route(val) {
      // console.log(val);
      if (val.params && val.params.tab) {
        this.tab = val.params.tab;
      }
    },
  },
  mounted() {
    var _this = this;
    // console.log(this.$route.params)
    this.listQuery.languageType = this.$i18n.locale;
    this.listQuery2.languageType = this.$i18n.locale;
    if (this.$route.params && this.$route.params.tab) {
      this.tab = this.$route.params.tab;
    }
    this.getList();
    this.getVideo()
  },
  methods: {
    addWatch(id){
      let _this = this
      if (!IsPC()) {
      document.getElementById(id).addEventListener(
        "pause",
        function (e) {
          let index = e.target.dataset.index
          let list = JSON.parse(JSON.stringify(_this.videoList))
          list[index].videoPlay =false
          _this.videoList = list
          _this.$forceUpdate
        },
        false
      );
      document.getElementById(id).addEventListener(
        "play",
        function (e) {
          let index = e.target.dataset.index
          let list = JSON.parse(JSON.stringify(_this.videoList))
          list[index].videoPlay =true
          _this.videoList = list
          _this.$forceUpdate
        },
        false
      );
    }
    },
    getList() {
      this.$loading.show();
      selectPatent(this.listQuery).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.listQuery.total = res.data.total;
          this.listQuery.totalPage = res.data.totalPage;
          this.patent = res.data.list;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    getVideo(){
      this.$loading.show();
      selectVideoList(this.listQuery2).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.listQuery2.total = res.data.total;
          this.listQuery2.totalPage = res.data.totalPage;
          this.videoList = res.data.list;
        } else {
          this.$message.error(res.msg);
        }
        setTimeout(() => {
          this.videoList.forEach(item=>{
            this.addWatch('video'+item.id)
          })
        }, 500);
      });
    },
    videoEvent(id,index) {
      let id1 = "video"+id
      let list = JSON.parse(JSON.stringify(this.videoList))
      list[index].videoPlay = list[index].videoPlay === null ? true: !list[index].videoPlay
      this.videoList = list
      this.$forceUpdate
      document.getElementById(id1).play();
    },
    sizeChange(page, size) {
      // console.log(page)
      this.listQuery.page = page;
      this.getList();
    },
    sizeChange2(page){
      this.listQuery2.page = page;
      this.getVideo();
    }
  },
};
</script>
<style lang="stylus" scoped>
@import '~@/assets/css/public.styl';
.English{ 
  .text1 {max-width:8rem;}
  .design-wrap .d-list .icon-tri:after{margin-top:-0.3rem}
  .design-wrap .d-list .d-list-item .icon-f{font-size:.14rem;padding-left:0;padding-right:0;
  span{display:table-cell;vertical-align:middle;height:.56rem;padding-left:.01rem;padding-right:.01rem}}
  .tech-b .d-list-item:last-child .tech-i-t{line-height:1.6;padding-bottom:0;padding-top:.1rem}
}
.design-wrap{padding-bottom:.24rem;text-align:justify}
.tech-li.video-li{
  height:auto;width:32%;margin-right:1.8%;margin-bottom:1.8%;
  &>div{padding:0}
  .section2-video{
    height: 2rem;width:100%
  }
  &:nth-child(3n){
    margin-right:0
  }
  .video-btn{left:50%;top:50%;}
  .video-btn img{width:0.48rem;height:0.48rem;}
  .tech-li-info{padding:0.18rem 0.2rem 0.25rem;display:block}
}
.tech-b{
  padding-top:.4rem;
  &>div {
    width:calc(50% - .14rem);
    height:1.48rem;
  }
  .d-list-item{
    background:#f6f6f6;margin-bottom:.24rem;
    .tech-i-t{width:calc(100% - 1.48rem);padding:.24rem .24rem .24rem .2rem;line-height:1.8;font-size:.14rem;text-align:justify}
    .tech-i{width:1.48rem;height:1.48rem;
      &::after{
        border-width: 0.08rem;margin-top: -0.08rem;border-left-color: #f6f6f6;width:.16rem;height:.16rem;top:0;bottom:0;margin:auto;
      }
      &.icon-tri-right::after{border-left-color:transparent;border-right-color:#f6f6f6}
    }
  }
}
.design-wrap {
  &>div {
    width: 50%;
  }
  .design-left {
    padding-right: 0.12rem;
    border-right: 0.02rem dotted #f9f9f9;

    .design-t {
      left: 0;
      right: 0;
      margin: auto;
      top: 0;
      color: #fff;
      bottom: 0;
      text-align: center;
      line-height: 1.8;
      height: 1.2rem;

      .d1 {
        font-size: 0.32rem;
        font-weight: bold;
      }

      .d2 {
        font-size: 0.28rem;
        font-weight: 500;
      }
    }

    .d3 {
      font-size: 0.14rem;
      color: #666;
      line-height: 2.3;
      padding: 0.28rem 0;
    }
  }

  .d-list {
    padding-left: 0.12rem;

    .d-list-item {
      padding: 0.16rem 0;
      border-bottom: 0.02rem dotted #f9f9f9;
      &:first-child .icon-f{background:#296799}
      &:last-child .icon-f{background:#348cd4}
      .fl {
        font-size: 0.14rem;
        line-height: 1.8;
        color: #666;
        width: calc(100% - 0.8rem);
        padding-right: 0.14rem;
        padding-top: 0.1rem;
      }

      .icon-f {
        background: #317dbb;
        font-size: 0.18rem;
        font-weight: bold;
        width: 0.8rem;
        height: 0.8rem;
        color: #fff;
        padding: 0.12rem 0.15rem;
        text-align: center;
       
      }
    }

    .icon-tri:after {
      border-width: 0.04rem;
      border-left-color: #fff;
      margin-top: -0.04rem;
    }
  }
}
.tech-img{width:100%;height:auto}

.realize-more {
  user-select: none;
  cursor: pointer;
}

h2, h3, h4, h5, h6, p {
  margin: 0;
}

.tech-t {
  padding-top: 0.7rem;
  padding-bottom: 0.4rem;
}

.banner {
  height: 280px;
  background: url('~@/assets/images/tech/banner.jpg') no-repeat center / auto 100%;
}

.tab-nav>div {
  width: 33.33%;
}

.tab-content {
  margin-bottom: 1.45rem;
  padding: 0 0.49rem .8rem;
  background: #fff;
}

.text1 {
  font-size: 0.14rem;
  color: #666666;
  margin: 0 auto;
  line-height: 0.32rem;
}


video {
  width: 100%;
  height: 100%;
  left:0;
  top:0;background:#000
}


.tech-table-w {
  padding: 0 0.5rem;
  padding-bottom: 1.2rem;
}

.tech-table {
  width: 100%;
  background: #f8f8f8;
  min-height: 3rem;
}

.tech-cell {
  width: 50%;
  vertical-align: middle;
  padding: 0.3rem 0.38rem;
  position: relative;
}

.tech-title {
  font-size: 0.24rem;color:#333;
}

.tech-label {
  font-size: 0.16rem;
  padding-bottom: 0.25rem;
}

.tech-text {
  font-size: 0.14rem;
  line-height: 0.32rem;
}

.tech-img1 {
  background: url('~@/assets/images/tech/img1.png') no-repeat center / cover;
}

.tech-img2 {
  background: url('~@/assets/images/tech/img2.png') no-repeat center / cover;
}

.tech-img3 {
  background: url('~@/assets/images/tech/img3.png') no-repeat center / cover;
}

.tech-ul {
  padding-top: 0.2rem;
}

.tab1 {
  background: #fff;
}

@media screen and (min-width: 768px) {
  
  .tab3{background:#f8f8f8;padding-left:0;padding-right:0}
}
@media screen and (max-width: 768px) {
  .English{
    .design-wrap .d-list .d-list-item{
      .fl{line-height:1.1;padding-top:0}
      .icon-f{font-size:.22rem;padding-top:.32rem}
    } 
    .tech-b .d-list-item .tech-i-t{line-height:1.3}
    .tech-b .d-list-item:last-child .tech-i-t{line-height:1}
  } 
  .section-wrap {
    padding: 0;
  }

  .banner {
    height: 3.7rem;
    background: url('~@/assets/images/tech/m-banner.jpg') no-repeat center / auto 100%;
  }

  .tab-content {
    background: #f8f8f8;
    margin-bottom: 0;
    padding:0 0.45rem .8rem
  }

  .tab1 {
    background: #f8f8f8;
  }

  .text1 {
    font-size: 0.26rem;
    width: 100%;
    line-height: 0.56rem;
    padding: 0;
    text-align: justify
  }
  .design-wrap {
    padding-bottom:.36rem;
    &>div{width:100%}
    .design-left{
      border-right: 0;
      border-bottom:0.02rem dotted #f4f4f4;padding-right:0;
      .d3{font-size:.26rem;line-height:1.8;padding-bottom:.2rem}
    }
    .d-list{
      padding-left:0;padding-top:.2rem;padding-bottom:.24rem;
      .d-list-item{
        .fl{font-size:.24rem;width:calc(100% - 1.14rem);padding-right:0;padding-left:.12rem;}
        .icon-f{width:1.14rem;height:1.14rem;font-size:.26rem;padding:0.15rem 0.2rem;
        
          &::after{
            border-width: 0.06rem;margin-top: -0.06rem;border-left-color: #f6f6f6;width:.16rem;height:.12rem;top:0;bottom:0;margin:auto;right:-1px;
          }
          &.icon-tri-right::after{border-left-color:transparent;border-right-color:#f6f6f6}
        }
      }
    }
  }
  .tech-li.video-li{
    width:100%;margin-right:0;margin-bottom:.24rem;
    .section2-video{
      height:3.7rem
    }
    .video-btn img{width:.84rem;height:.84rem}
    .tech-li-info{height:1.54rem;padding-top:.36rem}
  }
  .video {
    border-radius: 0;
  }

  .tech-title {
    font-size: 0.3rem;padding-top:.8rem;padding-bottom:.32rem
    &.sec{padding-bottom:.48rem;padding-top:.6rem}
  }

  .tech-cell {
    padding: 0.3rem 0.2rem;
  }

  .tech-table {
    background: #fff;
    min-height: 4.66rem;
  }

  .tech-label {
    font-size: 0.24rem;
    padding-bottom: 0.15rem;
  }

  .tech-text {
    font-size: 0.24rem;
    line-height: 0.4rem;
  }

  .tech-table-w {
    padding: 0;
    margin-top: 0.55rem;
  }

  .tech-img1 {
    background: url('~@/assets/images/tech/img1-m.png') no-repeat center / cover;
  }

  .tech-img2 {
    background: url('~@/assets/images/tech/img2-m.png') no-repeat center / cover;
  }

  .tech-img3 {
    background: url('~@/assets/images/tech/img3-m.png') no-repeat center / cover;
  }

  .tech-ul {
    width: 100%;
    margin: 0 auto;
  }
  .tech-b{
    &>div{width:100%}
    .d-list-item{
      .tech-i-t{font-size:.24rem;background:#fff;padding-top:0.1rem;padding-bottom:.1rem;min-height:1.48rem}
      &.last-tech .tech-i-t{padding-top:0;line-height:1.25;padding-bottom:0}
    }
  }
  .pagination{width:100%}
}
</style>
<style >
body {
  background: #f8f8f8;
}
</style>
